module.exports = [
  require('./motivational_speech'),
]
